import { useState } from "react";
import { Ban } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export const BlockButton = ({ targetId, targetName, onBlocked, compact = false }) => {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);

  const doBlock = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await api.post(`/blocks/${targetId}`);
      toast.success(`${targetName} est bloqué·e — vous ne vous verrez plus et ne pourrez plus échanger.`);
      onBlocked?.();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
      setConfirming(false);
    }
  };

  if (confirming) {
    return (
      <span className={`flex items-center gap-2 ${compact ? "" : "rounded-full border border-red-200 bg-red-50 px-3 py-1.5"}`} data-testid="block-confirm">
        <span className="text-xs font-semibold text-red-700">Bloquer {targetName} ?</span>
        <button onClick={doBlock} disabled={busy} data-testid="block-confirm-yes" className="rounded-full bg-red-600 px-3 py-1 text-xs font-semibold text-white hover:bg-red-700 disabled:opacity-50">
          {busy ? "…" : "Oui"}
        </button>
        <button onClick={() => setConfirming(false)} data-testid="block-confirm-no" className="rounded-full px-2 py-1 text-xs font-semibold text-clay hover:text-ink">
          Non
        </button>
      </span>
    );
  }

  return (
    <button
      onClick={() => setConfirming(true)}
      data-testid="block-button"
      title={`Bloquer ${targetName}`}
      className={
        compact
          ? "flex h-9 w-9 items-center justify-center rounded-full border border-[#D97B8F]/30 bg-white text-clay transition-colors hover:border-red-300 hover:text-red-600"
          : "flex items-center gap-1.5 rounded-full border border-terra/20 bg-white px-4 py-2 text-xs font-semibold text-clay transition-colors hover:border-red-300 hover:text-red-600"
      }
    >
      <Ban size={compact ? 15 : 13} /> {compact ? null : "Bloquer"}
    </button>
  );
};
